<template lang="pug">
  .container-main-mobile
    c-header
      template(slot="left")
        h3 商家资料
      template(slot="right")
        el-button(type="primary", @click="showEdit", :disabled="mchDetail.status === 2 && mchDetail.id !== 0") 修改资料
    .data-block
      data-row(label="商户类型") {{ mchDetail.type | type }}
    template(v-if="mchDetail.type === 1")
      .data-block
        data-row(label="公司名称") {{ mchDetail.mch_name }}
        template(v-if="mchDetail.uni_credit")
          data-row(label="统一社会信用代码或注册号") {{ mchDetail.uni_credit }}
        template(v-else)
          data-row(label="营业执照号") {{ mchDetail.business_license }}
          data-row(label="组织机构代码") {{ mchDetail.organization_code }}
          data-row(label="税务登记证件号") {{ mchDetail.tex_registration_no }}
      .data-block
        data-row(label="法人姓名") {{ mchDetail.legal_per_name }}
        data-row(label="法人证件类型") {{ mchDetail.legal_per_id_type | resp_per_id_type }}
        data-row(label="法人证件号码") {{ mchDetail.legal_per_id_no }}
        data-row(label="法人手机号") {{ mchDetail.legal_per_telephone_no || '未绑定' }}
      .data-block
        data-row(label="责任人姓名") {{ mchDetail.resp_per_name }}
        data-row(label="责任人证件类型") {{ mchDetail.resp_per_id_type | resp_per_id_type }}
        data-row(label="责任人证件号") {{ mchDetail.resp_per_id_no }}
        data-row(label="责任人邮箱") {{ mchDetail.resp_per_email || '未绑定' }}
        data-row(label="责任人手机") {{ mchDetail.resp_per_telephone_no || '未绑定' }}
      .data-block
        data-row(label="结算方式") {{ mchDetail.settle_type | settle_type_long }}
        data-row(label="开户名") {{ mchDetail.public_account_name }}
        data-row(label="对公账户账号") {{ mchDetail.public_account }}
        data-row(label="开户银行") {{ mchDetail.deposit_bank }}
        data-row(label="支行名称") {{ mchDetail.sub_branch_bank }}
        data-row(label="公司地址") {{ mchDetail.business_address }}
        data-row(label="商户电话") {{ mchDetail.tel }}

    template(v-if="mchDetail.type === 2")
      .data-block
        data-row(label="个人姓名") {{ mchDetail.resp_per_name }}
        data-row(label="结算方式") {{ mchDetail.settle_type | settle_type_long }}
        data-row(label="证件类型") {{ mchDetail.resp_per_id_type | resp_per_id_type }}
        data-row(label="证件号码") {{ mchDetail.resp_per_id_no }}
        data-row(label="联系地址") {{ mchDetail.business_address }}
        data-row(label="邮箱") {{ mchDetail.resp_per_email || '未绑定' }}
        data-row(label="手机") {{ mchDetail.resp_per_telephone_no || '未绑定' }}
    .data-block
      data-row(label="营业执照")
        img(v-if="mchDetail.business_license_pic", :src="mchDetail.business_license_pic | image",
          @click="$zoom($options.filters.image(mchDetail.business_license_pic))").mch-image
        template(v-else) 未提交
    .data-block
      data-row(label="法人证件正面")
        img(v-if="mchDetail.legal_per_id_positive", :src="mchDetail.legal_per_id_positive | image",
          @click="$zoom($options.filters.image(mchDetail.legal_per_id_positive))").mch-image
        template(v-else) 未提交
    .data-block
      data-row(label="法人证件反面")
        img(v-if="mchDetail.legal_per_id_opposite", :src="mchDetail.legal_per_id_opposite | image",
          @click="$zoom($options.filters.image(mchDetail.legal_per_id_opposite))").mch-image
        template(v-else) 未提交
    .data-block
      data-row(label="责任人证件正面")
        img(v-if="mchDetail.resp_per_id_opposite", :src="mchDetail.resp_per_id_opposite | image",
          @click="$zoom($options.filters.image(mchDetail.resp_per_id_opposite))").mch-image
        template(v-else) 未提交
    .data-block
      data-row(label="责任人证件反面")
        img(v-if="mchDetail.resp_per_id_opposite", :src="mchDetail.resp_per_id_opposite | image",
          @click="$zoom($options.filters.image(mchDetail.resp_per_id_opposite))").mch-image
        template(v-else) 未提交
    .data-block
      data-row(label="对公证明")
        img(v-if="mchDetail.public_account_pic", :src="mchDetail.public_account_pic | image",
          @click="$zoom($options.filters.image(mchDetail.public_account_pic))").mch-image
        template(v-else) 未提交


    .data-block
      data-row(label="温馨提示", v-if="!mchDetail.resp_per_email && !mchDetail.resp_per_telephone_no")
        .grey 您的资料还不完整，请尽快补充以免影响业务正常开展。
      data-row(label="商家资料状态", v-if="mchDetail.status !== 1") {{ mchDetail.status | status }}
      data-row(label="驳回原因", v-if="mchDetail.status === 4") {{ mchDetail.audit_msg }}
      data-row(value-only, v-if="mchDetail.status === 2 && mchDetail.id !== 0") 
        el-button(type="primary", @click="revokeEdit(mchDetail.id)") 撤回资料编辑
</template>

<script>
export default {
  data () {
    return {
      mchDetail:  {},
    };
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo;
    },
  },
  filters: {
    type (source) {
      switch (source) {
        case 1:     return '公司';
        case 2:     return '个人';
        default:    return source;
      }
    },
    status (source) {
      if (!source && source !== 0) {
        return '-';
      }
      switch (parseInt(source)) {
        case 1:
          return "填写中";
        case 2:
          return "审批中";
        case 3:
          return "审批通过";
        case 4:
          return "审批失败";
        case 5:
          return "用户撤回修改";
        case 6:
          return "审批中";
        default:  return source;
      }
    },
    settle_type (source) {
      switch (source) {
        case 1:     return '银行账号';
        case 2:     return '钱包账号';
        default:    return source;
      }
    },
    resp_per_id_type (source) {
      switch (source) {
        case '01':  return '身份证';
        default:    return source;
      }
    },
  },
  methods: {
    getUserInfo () {
      return this.$store.dispatch('GET_USER_INFO');
    },
    getMchDetail () {
      const { uname } = this.userInfo;
      return this.$store.dispatch('GET_MCH_DETAIL', uname).then((data) => {
        this.mchDetail = data;
        return data;
      }).catch(({ code, msg }) => {
        this.$alert(`商家资料获取失败。${code}：${msg}`, {
          type:     'error'
        });
      });
    },

    showEdit () {
      this.$router.push('/main-mobile/edit');
    },

    revokeEdit (mch_draft_id) {
      this.$confirm('是否确认撤回已提交审批的商家信息？', '提示').then(() => {
        return this.$store.dispatch('REVOKE_MCH_DRAFT', mch_draft_id).then(() => {
          this.getMchDetail();

          this.$message({
            type:     'success',
            message:  '撤回成功'
          });
        }).catch(({ code, msg }) => {
          this.$message({
            type:     'error',
            message:  `撤回失败。${code}：${msg}`,
          });
        });
      }).catch(() => {

      });
    },
  },
  mounted () {
    this.getUserInfo().then((userInfo) => {
      if (userInfo.fill_info === 1 && this.$route.path !== '/reg-mobile/2') {
        this.$router.replace('/reg-mobile/2');
      } else {
        this.getMchDetail();
      }
    });
  },
};
</script>
